import { Card, CardContent } from "@/components/ui/card";
import { Star, Quote } from "lucide-react";
import { useNavigate } from "react-router-dom";

export const TestimonialsSection = () => {
  const navigate = useNavigate();
  const testimonials = [
    {
      id: 1,
      name: "Pierre Dubois",
      company: "Carrelage Expert Lyon",
      role: "Carreleur depuis 15 ans",
      image: "/images/artisan_carreleur_1.jpeg",
      rating: 5,
      text: "Les disques Elite Precision ont révolutionné mon travail. La coupe est d'une précision incroyable, même sur les grès cérame les plus durs. Moins d'écaillage, moins de retouches, plus de productivité !",
      product: "Elite Precision Pro"
    },
    {
      id: 2,
      name: "Marc Lefebvre",
      company: "Maçonnerie Moderne",
      role: "Maçon professionnel",
      image: "/images/artisan_macon_1.jpeg",
      rating: 5,
      text: "Avec les disques ElitePro, je peux couper tous types de matériaux sans changer d'outil. La durée de vie est exceptionnelle, c'est un vrai investissement rentable pour mon entreprise.",
      product: "ElitePro Universal"
    },
    {
      id: 3,
      name: "Sébastien Martin",
      company: "Rénovation Premium",
      role: "Artisan polyvalent",
      image: "/images/artisan_carreleur_2.png",
      rating: 5,
      text: "Service client au top, livraison rapide et produits de qualité professionnelle. OutilMatPro est devenu mon fournisseur de référence pour tous mes chantiers.",
      product: "Elite Precision + ElitePro"
    }
  ];

  const stats = [
    { number: "5000", label: "Professionnels satisfaits" },
    { number: "98%", label: "Taux de satisfaction" },
    { number: "15 ans", label: "D'expérience" },
    { number: "24h", label: "Délai de livraison" }
  ];

  return (
    <section className="py-20 bg-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Ils nous font confiance
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Découvrez les témoignages de nos clients professionnels qui utilisent nos outils au quotidien
          </p>
        </div>

        {/* Statistiques */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-3xl md:text-4xl font-bold text-orange-500 mb-2">
                {stat.number}
              </div>
              <div className="text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Témoignages */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="bg-white hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  <Quote className="h-8 w-8 text-orange-500 mr-3" />
                  <div className="flex">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="h-4 w-4 text-yellow-500 fill-current" />
                    ))}
                  </div>
                </div>
                
                <p className="text-gray-700 mb-6 italic">
                  "{testimonial.text}"
                </p>
                
                <div className="flex items-center">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <div className="font-bold text-gray-900">{testimonial.name}</div>
                    <div className="text-sm text-gray-600">{testimonial.role}</div>
                    <div className="text-sm text-blue-600 font-medium">{testimonial.company}</div>
                  </div>
                </div>
                
                <div className="mt-4 pt-4 border-t">
                  <div className="text-xs text-gray-500">Produit utilisé :</div>
                  <div className="text-sm font-medium text-orange-600">{testimonial.product}</div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Call to action */}
        <div className="text-center mt-16">
          <div className="bg-white rounded-2xl p-8 shadow-lg max-w-2xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Rejoignez nos clients satisfaits
            </h3>
            <p className="text-gray-600 mb-6">
              Testez nos outils professionnels et découvrez la différence de qualité
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => navigate('/essai-elite-precision')}
                className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-lg font-medium transition-colors text-center"
              >
                Demander un échantillon
              </button>
              <a href="#contact" className="border border-orange-500 text-orange-500 hover:bg-orange-50 px-6 py-3 rounded-lg font-medium transition-colors text-center">
                Voir nos références
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};